//@flow

// Vendors
import React from 'react';

// Routes
import { RoutesPublicBasic } from '../../../routes';

// Components
import { Footer } from '../../../components';
import PublicLayoutBase from '../PublicLayoutBase';

// Styles
import './basic-public-layout.scss';

const BasePublicLayout = () => (
  <PublicLayoutBase>
    <div className="layout basic-public-layout">
      <RoutesPublicBasic />
      <Footer />
    </div>
  </PublicLayoutBase>
);

export default BasePublicLayout;
